import React, { Component } from 'react';
import LocationInfo from '../../Components/Location-Info/Location-Info';
// import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
// import { Popover, PopoverBody } from 'reactstrap';
import "./New-Location.scss";
// import TabLocal from '../../Components/TabLocal/TabLocal';


class NewLocation extends Component {

    constructor(props) {
        super(props);

        this.Configurations = new Configurations();

        this.state = {
        }

    }

    componentWillMount() {
    }

    render() {
        return (
            <div className="row new-location logistics">
                <div className="col-10">
                    <h2 className="title-1">Novo local de entrega</h2>
                </div>
                <div className='col-2'>
                    <button className='btn btn-outline-secondary text-right'onClick={() => this.props.history.push('/logistica/locais-entrega')}>Voltar</button>
                </div>
                <div className="col-12 py-2">
                    <div className="card">
                        <div className="card-body">
                            {/* <TabLocal toggleModal={this.props.toggleModal} history={this.props.history} /> */}
                            <LocationInfo />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default NewLocation;